<template>
	<WindowForAlert :title="$t('cmd140',['高级筛选'])" :size="'m'" ref="alarmFilter" id="alarmFilter">
		<!-- <div class="mt1x" :title="$t('word75',['类型'])">{{$t('word75',['类型'])}}:</div>
		<div class="mt05x lh15 mr1x_E curP_E">
			<label><input type="radio" name="type" v-model="filterAdvTemp.type.active" :value="null">{{$t('cmd19',['全部'])}}</label>
			<label v-for="plant in getTypeText('','alarmType',true)" :key="plant.id[0]"><input type="radio" name="type" v-model="filterAdvTemp.type.active" :value="plant.id[0]">{{plant.name}}</label>
		</div> -->
		<div :title="$t('word115',['等级'])">{{$t('word115',['等级'])}}:</div>
		<div class="mt05x lh15 mr1x_E curP_E">
			<!-- <label><input type="radio" name="level" v-model="filterAdvTemp.level.active" :value="null">{{$t('cmd19',['全部'])}}</label> -->
			<!-- <label v-for="plant in getTypeText('','alarmLevelFilter',true)" :key="plant.id[0]"><input type="radio" name="level" v-model="filterAdvTemp.level.active" :value="plant.id[0]">{{plant.name}}</label> -->
			<Checkbox :data="filterAdvTemp.levelList.active" :text="$t('cmd19',['全部'])" @Click="v=>{this.objTool(this.filterAdvTemp.levelList.active,'setAll',{value:v});}" @Empty="objTool(filterAdvTemp.levelList.active,'setAll',{value:true})"></Checkbox>
			<Checkbox v-for="obj in getTypeText('','alarmLevelFilter',true)" :key="obj.id[0]" v-model="filterAdvTemp.levelList.active[obj.id[0]]" :text="obj.name"></Checkbox>
		</div>
		<div class="mt1x" :title="$t('word1481',['影响范围'])">{{$t('word1481',['影响范围'])}}:</div>
		<div class="mt05x lh15 mr1x_E curP_E">
			<!-- <label><input type="radio" name="scope" v-model="filterAdvTemp.influence.active" :value="null">{{$t('cmd19',['全部'])}}</label> -->
			<!-- <label v-for="plant in getTypeText('','alarmFilterScope',true)" :key="plant.id[0]"><input type="radio" name="scope" v-model="filterAdvTemp.influence.active" :value="plant.id[0]">{{plant.name}}</label> -->
			<Checkbox :data="filterAdvTemp.influenceList.active" :text="$t('cmd19',['全部'])" @Click="v=>{this.objTool(this.filterAdvTemp.influenceList.active,'setAll',{value:v});}" @Empty="objTool(filterAdvTemp.influenceList.active,'setAll',{value:true})"></Checkbox>
			<Checkbox v-for="obj in getTypeText('','alarmFilterScope',true)" :key="obj.id[0]" v-model="filterAdvTemp.influenceList.active[obj.id[0]]" :text="obj.name"></Checkbox>
		</div>
		<div v-if="alarmObjSelect&&(type==null)" class="mt1x" :title="$t('word1625',['报警对象'])">{{$t('word1625',['报警对象'])}}:</div>
		<div v-if="alarmObjSelect&&(type==1)" class="mt1x" :title="$t('word164',['设备'])">{{$t('word164',['设备'])}}:</div>
		<AlarmStation v-if="alarmObjSelect && (type==null||type==1)" :filter="filterAdvTemp" :type="type" :targetId="plantIdLists[0]" :powerTypeList="powerTypeList" class="mt05x" @Update="UpdateObj" ref="AlarmStation"></AlarmStation>
		<!-- <div class="mt05x lh15 mr1x_E curP_E">
			<Checkbox :text="$t('cmd91',['全选'])" :triggerClick="false" :status="selectAllScope" @Click="selectScope"></Checkbox>
		</div> -->
		<!-- <div class="mt2x" :title="$t('word736',['并网类型'])">{{$t('word736',['并网类型'])}}</div>
		<div class="mt05x lh15 mr1x_E curP_E">
			<label><input type="radio" name="gridType" v-model="filterAdvTemp.gridInterconnectionType.active" :value="null">{{$t('cmd19',['全部'])}}</label>
			<label v-for="grid in getTypeText('','plantGridType',true)" :key="grid.id[0]"><input type="radio" name="gridType" v-model="filterAdvTemp.gridInterconnectionType.active" :value="grid.id[0]">{{grid.name}}</label>
		</div>
		<div class="mt2x" :title="$t('word727',['装机容量'])+'(kWp)'">{{$t('word727',['装机容量'])+'(kWp)'}}</div>
		<div class="mt05x dpIB_E vaM_E">
			<InputText class="w40pct" :placeholder="getLanguageStr('plant27','最小装机容量,不填则无下限')" ref="filterAdvPowerLower" v-model="filterAdvTemp.powerArea.active[0]"></InputText>
			<span class="w1x taC">~</span>
			<InputText class="w40pct" :placeholder="getLanguageStr('plant28','最大装机容量,不填则无上限')" ref="filterAdvPowerHigher" v-model="filterAdvTemp.powerArea.active[1]"></InputText>
		</div>
		<div class="mt2x" :title="getLanguageStr('word1711','投产状态')">{{getLanguageStr('word1711','投产状态')}}</div>
		<div class="mt05x lh15 mr1x_E curP_E">
			<label v-for="run in getTypeText('','runStateS',true)" :key="run.id[0]"><input type="radio" name="runState" v-model="filterAdvTemp.runState.active" :value="run.id[0]">{{run.name}}</label>
		</div>
		<div class="mt2x" :title="$t('manage76',['成员'])">{{$t('manage76',['成员'])}}</div>
		<div class="mt05x">
			<related-person class="w90pct" title="" :max-select="[5,'fill3rd75']" @Update="updatePersonList" ref="SearchPerson"></related-person>
		</div>
		<TagManageCore :type="1" :maxAddNum='Number(5)' :list="filterAdvTemp.tag.list" @Update="(action,data)=>{$emit('Update',action,data);}" class="mt2x posR" ref="TagManageCore"></TagManageCore> -->
		<button slot="btmBtn" class="functionBtn close"  @click="filterConfirm" :title="$t('cmd12',['确定'])" type="button">{{$t('cmd12',['确定'])}}</button>
	</WindowForAlert>
</template>
<script>
import WindowForAlert from '@/components/common/ui/WindowForAlert.vue'
import Checkbox from "@/components/common/ui/Checkbox.vue"
import AlarmStation from "@/view/maintain/alarm/part/AlarmStation.vue"
import * as lib from "@/util/lib"
import {getLanguageStr} from "@/util/language"
export default {
	name:'alarmFilter',
	components:{WindowForAlert,Checkbox,AlarmStation},
	props:{
		plantIdLists:{
			type:Array,
			default:()=>[]
		},
		type:{//1:电站；2:设备
			type:Number,
			default:null
		},
		targetId:{//对象id，用于锁定针对某对象的操作
			type:Number,
			default:null
		},
		alarmObjSelect:{//报警对象选择功能
			type:Boolean,
			default:true
		},
		powerTypeList:{//区电站时筛选目标类型
			type:Array,
			default:undefined
		}
	},
	data(){
		return{
			filterAdvTemp:{
				type:{
					request:true,
					name:getLanguageStr('word75','类型'),
					def:null,
					active:null,
					tagKey:"alarmType",
					type:"radio"
				},
				levelList:{
					request:true,
					name:getLanguageStr('word115','等级'),
					// def:null,
					// active:null,
					def:{0:true,1:true,2:true},
					active:{0:true,1:true,2:true},
					tagKey:"alarmLevelFilter",
					type:"checkbox"
				},
				influenceList:{
					request:true,
					name:getLanguageStr('word1481','影响范围'),
					// def:null,
					// active:null,
					def:{0:true,1:true,2:true,3:true},
					active:{0:true,1:true,2:true,3:true},
					tagKey:"alarmFilterScope",
					type:"checkbox"
				},
				plantIdList:{
					request:true,
					def:this.plantIdLists?this.plantIdLists:[],
					active:this.plantIdLists?this.plantIdLists:[],
				},
				deviceIdList:{
					request:true,
					def:[],
					active:[]
				},
				alarmObj:{
					name:getLanguageStr('word1625','报警对象'),
					def:"",
					active:"",
				}
			},
			filterAdv:{},
			resetFilter:{}
		}
	},
	computed:{
	},
	methods:{
		getLanguageStr,
		getTypeText:lib.getTypeText,
		objTool:lib.objTool,
		show(obj){
			this.filterAdv={}
			this.$refs.alarmFilter.show();
			if(JSON.stringify(obj)!='{}'){
				this.resetFilter=_.cloneDeep(obj)
				this.filterAdvTemp={...this.filterAdvTemp,...this.resetFilter}//来自首页的时候需要之前的初始配置值filterAdvTemp
			}else{
				this.reset()
				if(this.$refs.AlarmStation) this.$refs.AlarmStation.reset();
			}
			if(this.$refs.AlarmStation) this.$refs.AlarmStation.show()
		},
		reset(){
			$.each(this.filterAdvTemp,(key,val)=>{
				if (this.filterAdvTemp[key].displayVal!=undefined) this.filterAdvTemp[key].displayVal=this.filterAdvTemp[key].displayValDef;	//初始化显示值
				if (this.filterAdvTemp[key].fullList!=undefined) this.filterAdvTemp[key].fullList=this.filterAdvTemp[key].fullListDef;	//初始化给组件的TagBox循环对象传值
				if ($.isPlainObject(this.filterAdvTemp[key].active)||this.filterAdvTemp[key].active != this.filterAdvTemp[key].def){
					if( $.isPlainObject(this.filterAdvTemp[key].active) ) {//obj格式的继续遍历初始化值
						$.each(this.filterAdvTemp[key].active,(k)=>{
							this.$set(this.filterAdvTemp[key].active,k,this.filterAdvTemp[key].def[k]);
						});
					}else if($.type(this.filterAdvTemp[key].active)=="array"){//数组格式单独深拷贝，否则因为引用问题导致bug
						$.extend(true,this.filterAdvTemp[key].active,this.filterAdvTemp[key].def);
					}else this.$set(this.filterAdvTemp[key],"active",this.filterAdvTemp[key].def);
				}
			});
		},
		UpdateObj(station,device){
			this.filterAdvTemp.plantIdList.active=$.isEmptyObject(station)? []:[station];
			this.filterAdvTemp.deviceIdList.active=device
			if(device.length){
				let deviceArr=[]
				device.forEach(el=>{
					deviceArr.push(el.name+el.serialNumber);
				})
				if(this.type==1){
					this.filterAdvTemp.alarmObj.active=deviceArr.join(',')
				}else{
					this.filterAdvTemp.alarmObj.active=station.name+'-'+deviceArr.join(',')
				}
				
			}else{
				this.filterAdvTemp.alarmObj.active=station.name
			}
		},
		//确认筛选
		filterConfirm(){
			statistic('A32','A3208');
			this.filterAdv=_.cloneDeep(this.filterAdvTemp);
			this.$emit('SearchList',this.filterAdv)
		}
	},
	mounted(){
		// lib.fillHeight()
		// lib.setScroll($("#alarmFilter [scroll]"))
	}
}
</script>

   


// WEBPACK FOOTER //
// src/view/maintain/alarm/part/FilterAdv.vue